<template>
  <div class="content-main">

    <div class="shanzha">

      <div class="logo-and-wish flex-box">
        <img class="logo" :src="$store.state.favicon">
        <div>{{$store.state.siteSlogan}}</div>
      </div>

      <div class="btn-submit btn-first" @click="goMessageCheck()">看留言</div>
      <div class="btn-submit btn-second" @click="goMessageCreate()">写留言</div>

    </div>

    <van-tabbar v-model="tabActive" active-color="#b17e94">
      <van-tabbar-item icon="wap-home">首页</van-tabbar-item>
      <van-tabbar-item icon="eye-o" @click="goMessageCheck()">看留言</van-tabbar-item>
      <van-tabbar-item icon="envelop-o" @click="goMessageCreate()">写留言</van-tabbar-item>
      <van-tabbar-item icon="manager-o" @click="goUserCenter()">个人中心</van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
import { Toast } from 'vant'

export default{
  data(){
    return {
      username: '',
      infos: [],
      update: false,
      no_message: false,
      tabActive: 0
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goUserCenter(){
      this.$router.replace("/user_center")
    },
    goMessageCheck(){
      this.$router.replace("/message_check")
    },
    goMessageCreate(){
      // if(this.$store.state.userinfo.silent == 1){
      //   Toast('系统正在维护中，暂时无法创建留言，仅可查看留言～')
      // }else if(this.checkTimeForCreate()){
      //   this.$router.replace("/message_create_combo")
      // }else{
      //   Toast('写留言时间为：早9点～晚24点\n其余时间仅可查看留言')
      // }

      // if(this.$store.state.userinfo.silent == 1){
      //   Toast('系统正在维护中，暂时无法创建留言，仅可查看留言～')
      // }else{
      //   this.$router.replace("/message_create_combo")
      // }
      this.$router.replace("/message_create_combo")
    },
    checkTimeForCreate(){
      let date = new Date()
      let hour = date.getHours()
      if(hour > 8 && hour < 24){
        return true
      }else{
        return false
      }
    }
  },
  mounted(){

  }
}
</script>

<style scoped>
.content-main{ min-height:100vh;background-color: #f8f8f8;color:#b17e94;}
.shanzha{padding:15px;padding-top:25px;}
.logo-and-wish{font-size:17px;margin-bottom:20px;justify-content:flex-start;}
.logo-and-slogan{align-items:center;}
.logo{height:100px;width:100px;border-radius:100px;margin-right:25px;}
.btn-submit{background:#b17e94;color:#fff;font-size:15px;font-weight:bold;height:45px;line-height:45px;width:65%;margin:0px auto;border-radius:5px;}
.btn-first{margin-top:40%;}
.btn-second{margin-top:20%;}
</style>
